<template>
    <li :style="getStyles()" class="flex justify-space-between items-center">
        <div class="title">{{ block.name }}</div>
        <button @click="addBlock" class="btn btn-xs btn-primary add-block-btn" title="Add to practice plan">
          <i class="fa-solid fa-plus"></i>
        </button>
    </li>
</template>

<script>
export default {
  name: 'practice-plan-block-category',
  props: [
    'block',
  ],
  methods: {
    getStyles() {
      const vm = this;
      return `border-left: 3px solid ${vm.block.practice_plan_block_category.color}`;
    },
    addBlock() {
      const vm = this;
      // Clone the block to avoid mutating the original
      const blockToAdd = JSON.parse(JSON.stringify(vm.block));
      vm.$notificationManager.emit('add-block-by-click', blockToAdd);
    },
  },
};
</script>
